
import './CSS/caracteresG0.scss';
//import schemaG0Haut from './Assets/table_caractère_g0-haut.svg';
//import schemaG0Bas from './Assets/table_caractère_g0-bas.svg';
import schemaG0HautPng from './Assets/table_caractère_g0-haut.png';
import schemaG0BasPng from './Assets/table_caractère_g0- bas.png';


export default function CaracteresG0()
{
    return (
        <div className='PageG0'>
            <div id='titre'>
                <h1>Jeu de caractères G0</h1>
            </div>
            <div id ="partie_haute">
                <img className="shemaG0scv" src={schemaG0HautPng} alt="table G0" />
            </div>
            <div id="partie_basse">
                <img  className="shemaG0scv" src={schemaG0BasPng} alt="table G0" />
            </div>
        </div>
    )
}